import { useContext, useMemo } from 'react';
import { isProduction } from 'src/libs/wa/utils/env';
import { BrowserCacheContext } from 'src/stores/BrowserCache';
import { ShopsContext } from 'src/stores/Shops';
import { useSharedState } from './useSharedState';

const DEFAULT_SHOP_ID = isProduction() ? 36 : 4;

export const useCurrentShop = () => {
  const shops = useContext(ShopsContext);
  const { shopId } = useContext(BrowserCacheContext);
  const shopIdFromStorage = shopId.get();
  const shopIdValue = shopIdFromStorage || DEFAULT_SHOP_ID;
  const defaultShop = useMemo(() => shops.find((shop) => shop.id === shopIdValue), [shopIdValue, shops]);
  const [currentShop, setCurrentShop] = useSharedState('currentShop', defaultShop);

  return { shops, shopId, shopIdValue, currentShop, setCurrentShop };
};
